import React from "react";

const QuintIcon = () => (
  <svg className="quint-icon" xmlns="http://www.w3.org/2000/svg" width="31" height="42" viewBox="0 0 31 42">
    <path d="M0 0h31v42H0z" fill="#fff" opacity="0" />
    <g transform="translate(2.426 2.114)">
      <path
        d="M25.719 37.758L13.761 23.833s-4.953-.118-6.75-.237c-5.087-.362-7.262-3.574-7.037-8.216 0 0 0-6.549.24-9.524C.476 1.332 2.771-.216 7.473.02A90.1 90.1 0 0 1 17.86 1.329c2.906.6 4.837 1.907 5.925 5.717.484 1.9 1.571 7.366 2.062 9.879.484 2.739.375 5.714-3.622 6.427l3.5 14.414"
        fill="#febf0f"
        transform="translate(.042 .003)"
      />
      <path
        d="M18.709 21.922a3.99 3.99 0 0 1-3.75-3.215c-.12-1.667-.484-6.786-.6-7.857-.12-1.549 1.327-2.38 2.9-2.144 1.451.237 3.139 1.19 3.262 2.857.24 1.785.844 5.832 1.087 7.617a2.511 2.511 0 0 1-2.9 2.739zm9.3-1.19c-.24-1.785-.967-5.477-1.451-7.617-.6-2.857-.724-5.477-4.59-6.19a67.019 67.019 0 0 0-10.75-1.072c-3.5.118-3.75 2.857-3.866 4.76-.12 2.025 0 7.144 0 8.452.12 3.215 1.207 4.287 2.175 4.882 1.327.713 2.055.832 4.71.832.484 0 5.193.118 5.193.118l6.408 8.094-2.659-8.212a16.732 16.732 0 0 0 2.9-.118c2.053-.595 2.173-2.261 1.929-3.929z"
        fill="#35144f"
        transform="translate(-4.546 -3.682)"
      />
    </g>
  </svg>
);

export default QuintIcon;
